// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JCjwJs7YVk_4olouREK0{width:100%;height:100%;display:flex;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/AutomationLogs/ui/AutomationLogsEmptyState/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,WAAA,CAEA,YAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JCjwJs7YVk_4olouREK0`
};
export default ___CSS_LOADER_EXPORT___;
